const Flickity = require('flickity');
require('flickity-imagesloaded');
require('lazysizes');

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

export default {

  init() {
    // this.navToggle();
    this.filterSetToggle();
    this.mobileSubmenuToggle();
    this.mobileNavToggle();
    this.megaMenuToggle();
    this.accordionToggle();
    this.eventListeners();
    this.chooserToggle();
    this.smoothScroll();
    this.sliderAccessiblity();
    this.cookieConsent();
    this.lightboxGallery();
    this.improveInsightLists();
    this.jumpToTop();

    $('html').removeClass('no-js').addClass('js');
  },


  jumpToTop() {
    $('#jump-to-top').on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, '400');
    });
  },

  improveInsightLists() {
    $('p').each(function () {
      const $p = $(this);
      const hasList = $p.next('ul').length > 0 || $p.next('ol').length > 0;
      if ($p.text().endsWith(':') && hasList) {
        $p.addClass('less-margin');
      }
    });
  },

  // allows users to open 
  lightboxGallery() {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.figure__image-wrap',
      children: 'a',
      pswpModule: PhotoSwipe
    });
    lightbox.init();
  },

  cookieConsent() {
    $('#accept-cookies').on('click', function (e) {
      e.preventDefault();

      var date = new Date(Date.now() + 365 * 864e5);
      document.cookie = "cookie_consent=true; expires=" + date.toUTCString() + "; path=/;";

      $(this).parents('.site-alert').fadeOut(300, function () {
        $(this).remove();
      });
      $('body').attr('data-has-cookie-consent', true);
    });
  },

  /*
   * Accessibility fix for focusable elements in sliders
   * @see https://github.com/metafizzy/flickity/issues/776#issuecomment-502526445
   */
  sliderAccessiblity() {

    var fixTabindex = function (flkty) {
      $(flkty.element).find('a').attr('tabindex', '-1');
      $(flkty.selectedElements).find('a').attr('tabindex', '0');

      console.log('flickity fix');
    }

    $('.slider').each(function () {
      var flkty = new Flickity.data(this);

      // Make sure flickity is already initialized
      if (flkty.element === undefined) {
        setTimeout(function () {
          Common.sliderAccessiblity();
        }, 50);
        return;
      }

      flkty.on('change', function (index) {
        fixTabindex(flkty);
      });

      fixTabindex(flkty);
    });
  },

  smoothScroll() {
    $('a.js-smooth-scroll').on('click', function (event) {
      var target = $($(this).attr('href'));
      if (target.length) {
        event.preventDefault();
        $('body').addClass('is-scrolling');
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500, function () {
          $('body').removeClass('is-scrolling');
        });
      }
    });
  },

  accordionToggle() {
    $('.accordion__toggle').on('click', function (e) {
      e.preventDefault();
      var $toggle = $(this);
      var $target = $($toggle.attr('data-target'));
      $toggle.toggleClass('is-open');
      $target.toggleClass('is-open');
    });
  },

  // Markup for the chooser elements used in the chooserToggle function

  /*
  ul.chooser__menu
    li[.is-active]
      a.chooser__toggle[data-target="#Chooser1Body1]
  select.chooser__select

  ul.chooser__content
    li.chooser__body[.is-active]
  */

  chooserToggle() {

    // Handle clicks on the toggles in the menu

    $('.chooser__toggle').on('click', function (e) {
      e.preventDefault();
      var $toggle = $(this);
      var $target = $($toggle.attr('data-target'));
      var targetId = $toggle.attr('data-target');
      var $targetActiveSibling = $target.siblings('.is-active');
      var $menu = $toggle.parents('.chooser__menu');
      var $activeToggles = $menu.find('.is-active');
      var $select = $menu.siblings('.chooser__select');

      // If the toggle isn't already active...
      if (!$toggle.hasClass('is-active')) {
        // Remove .is-active from current active menu item
        $activeToggles.removeClass('is-active');
        // Add class to current toggle
        $toggle.addClass('is-active');
        $toggle.parent('li').addClass('is-active');

        // Remove .is-active from current active .chooser__body
        $targetActiveSibling.removeClass('is-active');
        // Add class to target
        if (!$target.hasClass('is-active')) {
          $target.addClass('is-active');
        }

        // Keep the select menu in sync
        $select.val(targetId);
      }

    });

    // Handle changes in the parallel select menu

    $('.chooser__select').on('change', function (e) {
      e.preventDefault();
      var $select = $(this);
      var $target = $($select.val());
      var targetId = $select.val();
      var $targetActiveSibling = $target.siblings('.is-active');
      var $menu = $select.siblings('.chooser__menu');
      var $activeToggles = $menu.find('.is-active');
      var $targetToggle = $('.chooser__menu').find('a[data-target="' + targetId + '"]');

      // Remove .is-active from current active .chooser__body
      $targetActiveSibling.removeClass('is-active');
      // Add class to target
      if (!$target.hasClass('is-active')) {
        $target.addClass('is-active');
      }

      // Keep the menu in sync
      $activeToggles.removeClass('is-active');
      $targetToggle.addClass('is-active').parents('li').addClass('is-active');

    });
  },

  filterSetToggle() {
    $('.filter-set__toggle').on('click', function (e) {
      e.preventDefault();
      var $toggle = $(this);
      var $target = $toggle.parent('.filter-set');
      $target.toggleClass('is-open');
    });
  },

  mobileSubmenuToggle() {
    $('.header__nav-mobile-primary .has-submenu > a').on('click', function (e) {
      let $toggle = $(this);
      $toggle.parent('li').toggleClass('is-open');
      e.preventDefault();
    });
  },

  mobileNavToggle() {
    $('.header__nav-mobile-toggle').on('click', function (e) {
      let $toggle = $(this);
      let $header = $('.site-header');

      $header.toggleClass('is-nav-mobile-open');
      $('html').toggleClass('is-nav-mobile-open');

      // start the click watching to close the menu on clicks outside the header
      Common.clickOutsideClose();

      e.preventDefault();
    });
  },



  megaMenuToggle() {

    $('.header__mega-menu-toggle').on('click', function (e) {
      let $toggle = $(this);
      let $targetMenu = $($toggle.attr('data-target'));
      let $header = $('.site-header');
      let $html = $('html');
      let $megaOpens = $('.is-mega-open, .header__mega.is-open');

      if ($targetMenu.hasClass('is-open')) {
        $megaOpens.removeClass('is-mega-open is-open');
      } else {
        $megaOpens.removeClass('is-mega-open is-open');
        $html.addClass('is-mega-open');
        $header.addClass('is-mega-open');
        $toggle.addClass('is-mega-open');
        $targetMenu.addClass('is-open');
      }

      // start the click watching to close the menu on clicks outside the header
      Common.clickOutsideClose();

      e.preventDefault();

    });
  },

  navToggle() {
    $('.header__nav-toggle').on('click', function (e) {
      let $toggle = $(this);
      let $menu = $('.header__nav');

      $menu.toggleClass('is-nav-active');
      $('html').toggleClass('is-nav-open');

      if (!$('html').hasClass('is-nav-open')) {
        $('.nav-backdrop').remove();
      } else {
        $(document.createElement('div'))
          .addClass('nav-backdrop fade-in')
          .appendTo($('body'))
          .on('click', function () {
            $toggle.trigger('click');
          });
      }

      $('html').removeClass('is-dropdown-open');
    });

    $('.header__nav .close').on('click', function (e) {
      $('.header__nav-toggle').trigger('click');
    });

  },

  navState() {

    // Only reset on desktop
    if (this.isMobile()) {
      return;
    }

    $('html').removeClass('is-nav-open');
    $('.nav-backdrop').remove();
    $('html').removeClass('is-dropdown-open');
    $('.header__nav').toggleClass('is-nav-active');
  },

  fixedHeader() {

    // Header is only fixed on mobile
    if (!this.isMobile()) {
      $('html').removeClass('is-nav-fixed');
      return;
    }

    var scrollPos = window.scrollY;
    var threshold = $('.site-header').height();

    $('html').toggleClass('is-nav-fixed', (scrollPos >= threshold));
  },

  eventListeners() {
    const common = this;

    // Update on resize
    window.addEventListener('resize', function (e) {
      if (!common.ticking) {
        window.requestAnimationFrame(function () {
          common.navState();
          common.ticking = false;
        });

        common.ticking = true;
      }
    });

    // Update on scroll
    window.addEventListener('scroll', function (e) {
      if (!common.ticking) {
        window.requestAnimationFrame(function () {
          common.fixedHeader();
          common.ticking = false;
        });

        common.ticking = true;
      }
    });
  },

  isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  },

  clickOutsideClose() {

    // Stop clicks outside from propagating to the site header
    $('.site-header').on('click', function (e) {
      e.stopPropagation();
    });

    // Watch clicks on the window
    $('html').on('click', function (e) {

      // If mega menu is open, close it
      if ($('html').hasClass('is-mega-open')) {
        let $megaOpens = $('.is-mega-open, .header__mega.is-open');
        $megaOpens.removeClass('is-mega-open is-open');
        // Remove the handlers
        $('.site-header').off('click');
        $('html').off('click');
      }

      // If mobile nav is open, close it
      if ($('html').hasClass('is-nav-mobile-open')) {
        let $navOpens = $('.is-nav-mobile-open');
        $navOpens.removeClass('is-nav-mobile-open');
        // Remove the handlers
        $('.site-header').off('click');
        $('html').off('click');
      }

    });
  },

};
